export default class Clipboard {
    static copy(selection) {
        const data = JSON.stringify(selection);
        if (!data) {
            return false;
        }
        navigator.clipboard.writeText(data);
        return false;
    }

    static paste(tools, factory, selection, speciesCollection) {
        navigator.clipboard.readText()
            .then((text) => {
                try {
                    let data = JSON.parse(text);
                    Object.values(data.species).map((species) => {
                        speciesCollection.add(species);
                    });
                    selection.reset();
                    tools.setTool(
                        'placement',
                        data.elements.map(
                            (element) => factory.make(element)
                        )
                    )
                } catch (e) {
                }
            })
            .catch((e) => {
                // Clipboard read can be denied (e.g. permission refused or the
                // document isn't focused). Swallow it so a blocked paste doesn't
                // surface as an uncaught DOMException in error tracking.
                console.warn('Clipboard paste unavailable:', e);
            });
    }
}
